import { NotificationService } from '../api/Notifications/NotificationService'

import { wsUrl } from '../config'

export const notificationService = NotificationService.create()

notificationService.connect({ url: wsUrl })
